import { printReceipts } from '../index';

const handleWithAction = action => (
  response,
  cardPayment,
  hooks,
) => async dispatch => {
  if (response && response.data.records.length) {
    const result = response.data.records[0];
    const receipts = result.additionalData;

    /**
     * Swedbank currently does not support un-referenced refunds, so it should be OK to also check for the 0 > Number(cardPayment.amount)
     * Still prefer to check for .original since it feels safer
     * */
    const isRefund = cardPayment.original;

    if (
      result.transactionStatus === 'COMPLETED_REV' ||
      result.transactionStatus === 'COMPLETED'
    ) {
      action(result, cardPayment, hooks);
      dispatch(printReceipts(receipts));
      return result;
    }

    let msg = result.statusMessage;

    if (
      (result.resultCode === '1' && result.statusMessage.includes('327')) ||
      (result.resultCode === '1' && result.statusMessage.includes('0'))
    ) {
      // Tried to void a refund
      if (
        (result.rawResponse?.ReturnCode === '32781' ||
          result.statusMessage.includes('32781')) &&
        isRefund
      ) {
        msg = msg.concat(
          '\n\nNB! Cannot cancel a refunded payment. Please finalize the return and start a new sale to take payment from customer',
        );
      }
      hooks.updateMessage(msg);
      return 0;
    }

    if (result.transactionStatus === '') {
      hooks.updateMessage(
        `Unsuccessful cancellation - Cancelled. \n Status: ${result.statusMessage}`,
      );
      hooks.enableButtons(['retry', 'terminal-connection', 'close']);
      return false;
    }

    hooks.updateMessage(`Unsuccessful cancellation - ${result.statusMessage}`);
    hooks.enableButtons(['retry', 'terminal-connection', 'close']);
    return false;
  }

  hooks.updateMessage(
    `Unsuccessful cancellation.\n  Response is missing - ${JSON.stringify(
      response,
    )}`,
  );
  return hooks.enableButtons(['retry', 'terminal-connection', 'close']);
};

export const handleSuccessRefund = handleWithAction((result, pmt, hooks) =>
  hooks.beforeDocSave({
    key: pmt.key,
    type: 'CARD',
    amount: `-${result.approvedAmount}`,
    attributes: {
      refNo: `${result.authCode}.${result.referenceNumber}`,
    },
    paid: true,
  }),
);
export const handleSuccessVoid = handleWithAction((_, pmt, hooks) =>
  hooks.beforeDocDelete(pmt.key),
);
